import { AnyAction } from 'redux'
import actionTypes from '../actions/actionTypes'
import IAccessibilityData from '../../helpers/data/accessibilityData'

export interface IAccessibilityStore {
	[key: string]: IAccessibilityData
}

export const defaultState: IAccessibilityStore = {}

function updateAccessibilityData(state: IAccessibilityStore, action: AnyAction): IAccessibilityStore {
	return {
		...state,
		[action.id]: {
			altText: action.altText,
			isDecorative: action.isDecorative,
		},
	}
}

const accessibilityReducer = (state: IAccessibilityStore = defaultState, action: AnyAction): IAccessibilityStore => {
	switch (action.type) {
		case actionTypes.ACCESSIBILITY_DATA_FETCHED:
			return updateAccessibilityData(state, action)
		default:
			return state
	}
}

export default accessibilityReducer
